export { default as Answer } from './Answer'
export { default as Button } from './Button'
export { default as Card } from './Card'
export { default as Pagination } from './Pagination'
export { default as QuizHeadline } from './QuizHeadline'
export { default as ResultHeadline } from './ResultHeadline'
export { default as ResultItem } from './ResultItem'
export { default as ResultReport } from './ResultReport'
export { default as Spinner } from './Spinner'
export { default as ButtonGroup } from './ButtonGroup'



// WEBPACK FOOTER //
// ./src/components/index.js